export const PERSON = `{
  id
  owner
  language
  authorized_create
  authorized_read
  authorized_update
  authorized_delete
  invitation_firstname
  firstname
  invitation_lastname
  lastname
  invitation_email
  email
  phone
  postcode
  city
  partner_id
  lastUpdatedBy
  personSpaceId
  createdAt
  updatedAt
  __typename
  }`
